import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import ButtonDefault from 'app/components/ButtonDefault'

const mapDispatchToProps = (dispatch, { to, onClick, absolute = false, id = '' }) => ({
  onClick: () => {
    if (onClick) {
      throw new Error('"onClick" not allowed. Please use "to" for LinkButton instead')
    }
    if (!to) {
      throw new Error('"to" prop is required')
    }
    if (absolute) {
      const win = window.open(to, '_blank')
      win.focus()
    } else {
      return dispatch(push(to))
    }
  },
})

const LinkButton = connect(null, mapDispatchToProps)(ButtonDefault)

LinkButton.propTypes = {
  ...ButtonDefault.propTypes,
  to: PropTypes.string.isRequired,
  absolute: PropTypes.bool,
  id: PropTypes.string,
}

export default LinkButton
